import React, {useState, useContext, useEffect} from 'react';
import Spinner from '../../../Spinner';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectComponent';
import {ToastContainer} from 'react-toastify';
import HistoricoStatus from '../../HistoricoStatus';
import WhatshotRoundedIcon from '@mui/icons-material/WhatshotRounded';
import CrisisAlertOutlinedIcon from '@mui/icons-material/CrisisAlertOutlined';
import {Context} from '../../../../Helpers/Auth';
import { getMotivosPerdaNegocio, getStatusNegocio } from '../../api';

function Status({info, editar}) {
    const {t} = useTranslation();
    const {userRepresentante} = useContext(Context);

    const {
        loading,
        editarNegocio,
        setOnChangeForm,

        setConsulta,
        consulta,
        urgente,
        setUrgente,
        setHotDeal,
        hotDeal,
        etapas,
        setEtapaR,
        etapaR,
        setValidacaoEtapa,
        validacaoEtapa,

        setMotivoR,
        motivoR,
        setValidacaoMotivo,
        validacaoMotivo,
        setEstados,
        estados,
        setEstado,
        estado,
        setValidacaoEstado,
        validacaoEstado,
        motivos,
        negocio,
        negocioData,
        historicoStatus,
        setMotivos
    } = info;

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
       
        if (estados.length == 0) {
            getStatusNegocio(lang).then(res => {
                setEstados(res.data.status);
            });

            getMotivosPerdaNegocio(lang).then(res => {
                setMotivos(res.data.motivosPerdaNegocio);
            });
        }
    }, []);

    return (
        <>
            <div className={`${negocio ? 'grid gap-3 mb-6 md:grid-cols-2' : ''}`}>
                {loading && (
                    <div className="flex flex-row mt-14 justify-center">
                        <>
                            <Spinner />
                        </>
                    </div>
                )}
                <div>
                    {!loading && (
                        <>
                            <form>
                                <div className="grid gap-3 mb-6 md:grid-cols-9">
                                    <div className={`col-span-8`}>
                                        <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            {t('estado')}*
                                        </label>
                                        <SelectComponent
                                            options={userRepresentante.assina ? estados : estados.filter(e => !e.ganho)}
                                            value={estado}
                                            onChange={e => {
                                                setOnChangeForm(true);
                                                setEstado(e);
                                                setValidacaoEstado(false);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('selecioneOpcao')}
                                            isDisabled={!editarNegocio || !(!estado?.ganho || userRepresentante.assina)}
                                        />
                                        {validacaoEstado && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                    </div>
                                    {negocio != '' && estado?.value == '00003' && (
                                        <div className="mt-2 col-span-8">
                                            <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                {t('motivo')}*
                                            </label>

                                            <SelectComponent
                                                options={motivos}
                                                value={motivoR}
                                                onChange={e => {
                                                    setOnChangeForm(true);
                                                    setMotivoR(e);
                                                    setValidacaoMotivo(false);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('selecioneOpcao')}
                                                isDisabled={!editarNegocio}
                                            />
                                            {validacaoMotivo && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                        </div>
                                    )}
                                </div>

                                <div className="flex-row mb-2">
                                    <label className="relative mt-2 inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={hotDeal} onChange={() => setHotDeal(!hotDeal)} className="sr-only peer" />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                        <span className="flex items-center ml-3 text-sm font-bold text-red-600 dark:text-red-500">
                                            Hot Deal <WhatshotRoundedIcon />
                                        </span>
                                    </label>
                                </div>
                                <div className="flex-row mb-2">
                                    <label className="relative mt-2 inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={urgente} onChange={() => setUrgente(!urgente)} className="sr-only peer" />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>

                                        <span className="ml-3 text-sm font-bold text-orange-400 dark:text-orange-400 ">
                                            {t('propostaUrgente')} <CrisisAlertOutlinedIcon />
                                        </span>
                                    </label>
                                </div>
                                <div className="flex-row mb-4">
                                    <label className="relative mt-2 inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={consulta} onChange={() => setConsulta(!consulta)} className="sr-only peer" />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                        <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{consulta ? t('consulta') : t('naoConsulta')}</span>
                                    </label>
                                </div>
                                <div className="grid gap-3 mb-6 md:grid-cols-9">
                                    <div className={`col-span-8`}>
                                        <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            {t('etapa')}*
                                        </label>
                                        <SelectComponent
                                            options={etapas.filter(e => e.consulta == consulta)}
                                            value={etapaR}
                                            onChange={e => {
                                                setOnChangeForm(true);

                                                setEtapaR(e);

                                                setValidacaoEtapa(false);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('selecioneOpcao')}
                                            isDisabled={!editarNegocio}
                                            sort={false}
                                        />
                                        {validacaoEtapa && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                                    </div>

                                    <div
                                        className={`${
                                            negocio
                                                ? 'flex ml-12  justify-center items-center h-[250px] min-h-[1em] w-px self-stretch bg-gradient-to-tr from-transparent via-neutral-500  to-transparent opacity-20 dark:opacity-60'
                                                : ''
                                        }`}></div>
                                </div>
                            </form>
                        </>
                    )}
                </div>
                <div>
                    <div className={negocio ? 'block' : 'hidden'} id="link2">
                        <span className="block mb-4  text-lg font-medium text-gray-900 dark:text-white">{t('historicoStatus')}</span>
                        <HistoricoStatus historicoStatus={historicoStatus} negocioData={negocioData} />
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </>
    );
}

export default Status;
